import styled from 'styled-components';
import CompletedEmptySvg from '../../assets/mytrips/ic-completed-empty.svg';

const CompletedEmptyIcon = styled(CompletedEmptySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '12rem'};
  height: ${props => props.height || '11.4rem'};
  margin: ${props => props.margin};
`;

export default CompletedEmptyIcon;
